import EnumSealingLevel from "./gen/qsign/types/EnumSealingLevel";
const labels = {
    [EnumSealingLevel.QUALIFIED]: "Kvalifikovaný",
    [EnumSealingLevel.GUARANTEED]: "Zaručený",
    [EnumSealingLevel.NONE]:"Žádný",
};

export function getCaption(source) {
    const caption = labels[source];
    return caption ? caption : "[" + source + "]";
}